// extracted by mini-css-extract-plugin
export default {"empty-section":"lazyCompendiumRoutes_empty-section__wE4AJ"};